import * as React from 'react';
import { createDefaultApi } from '../../../webportal/utils/createApi';
import { copyToClipboard } from '../../../webportal/utils/utilFunctions';
import { ErrorRenderer } from './ErrorRenderer';

interface FSExtraInfoProps {
    filespaceName: string;
    domainName: string;
}

interface FSExtraInfoState {
    hubEndpoint: string;
    filespaceUUID?: string;
    isCopyButtonClicked: boolean;
    hasError: boolean;
    errorMessage: string;
}

export class HubInfo extends React.Component <FSExtraInfoProps, FSExtraInfoState> {

    constructor(props: FSExtraInfoProps) {
        super(props);
        this.state = {
            hubEndpoint: '',
            isCopyButtonClicked: false,
            hasError: false,
            errorMessage: ''
        };
    }

    render() {
        let copyClassName = 'copy';
        if (this.state.isCopyButtonClicked) {
            copyClassName = copyClassName + ' copied';
        }
        return (
            <li>
                Hub public IP:&nbsp;
                {!this.state.hubEndpoint && <a
                    href="javascript:void(0)"
                    onClick={async () => {await this.reportHubStats(this.props.domainName, this.props.filespaceName); }}
                >
                    Show
                </a>}
                <li>{this.state.hubEndpoint && this.state.hubEndpoint}
                {this.state.hubEndpoint && (
                <a
                    href="javascript:void(0);"
                    className={copyClassName}
                    onClick={() => {
                        if (!this.state.hubEndpoint) { return; }
                        copyToClipboard(this.state.hubEndpoint);
                        this.setState({isCopyButtonClicked: true});
                    }}
                >
                    <svg width="14px" height="17px" viewBox="0 0 14 17" version="1.1">
                        <path d="M1.45132743,11.8230088 L1.45132743,1.48672566 L10.300885,1.48672566 L10.300885,0 L1.45132743,0 C1.05014749,0 0.707964602,0.147492625 0.424778761,0.442477876 C0.14159292,0.737463127 0,1.08554572 0,1.48672566 L0,1.48672566 L0,11.8230088 L1.45132743,11.8230088 Z M12.5132743,16.2477876 C12.9144543,16.2477876 13.2625369,16.100295 13.5575221,15.8053097 C13.8525074,15.5103245 14,15.1622419 14,14.7610619 L14,14.7610619 L14,4.42477876 C14,4.02359882 13.8525074,3.68141593 13.5575221,3.39823009 C13.2625369,3.11504425 12.9144543,2.97345133 12.5132743,2.97345133 L12.5132743,2.97345133 L4.42477876,2.97345133 C4.02359882,2.97345133 3.67551622,3.11504425 3.38053097,3.39823009 C3.08554572,3.68141593 2.9380531,4.02359882 2.9380531,4.42477876 L2.9380531,4.42477876 L2.9380531,14.7610619 C2.9380531,15.1622419 3.08554572,15.5103245 3.38053097,15.8053097 C3.67551622,16.100295 4.02359882,16.2477876 4.42477876,16.2477876 L4.42477876,16.2477876 L12.5132743,16.2477876 Z M12.5132743,14.7610619 L4.42477876,14.7610619 L4.42477876,4.42477876 L12.5132743,4.42477876 L12.5132743,14.7610619 Z" />
                    </svg>
                </a>
                )}
                </li>
                {this.state.filespaceUUID && (
                    <li>
                        <span>UUID: {this.state.filespaceUUID}</span>
                        <a
                            href="javascript:void(0);"
                            className={copyClassName}
                            onClick={() => {
                            if (!this.state.filespaceUUID) { return; }
                            copyToClipboard(this.state.filespaceUUID);
                            this.setState({isCopyButtonClicked: true});
                            }}
                        >
                        <svg width="14px" height="17px" viewBox="0 0 14 17" version="1.1">
                            <path d="M1.45132743,11.8230088 L1.45132743,1.48672566 L10.300885,1.48672566 L10.300885,0 L1.45132743,0 C1.05014749,0 0.707964602,0.147492625 0.424778761,0.442477876 C0.14159292,0.737463127 0,1.08554572 0,1.48672566 L0,1.48672566 L0,11.8230088 L1.45132743,11.8230088 Z M12.5132743,16.2477876 C12.9144543,16.2477876 13.2625369,16.100295 13.5575221,15.8053097 C13.8525074,15.5103245 14,15.1622419 14,14.7610619 L14,14.7610619 L14,4.42477876 C14,4.02359882 13.8525074,3.68141593 13.5575221,3.39823009 C13.2625369,3.11504425 12.9144543,2.97345133 12.5132743,2.97345133 L12.5132743,2.97345133 L4.42477876,2.97345133 C4.02359882,2.97345133 3.67551622,3.11504425 3.38053097,3.39823009 C3.08554572,3.68141593 2.9380531,4.02359882 2.9380531,4.42477876 L2.9380531,4.42477876 L2.9380531,14.7610619 C2.9380531,15.1622419 3.08554572,15.5103245 3.38053097,15.8053097 C3.67551622,16.100295 4.02359882,16.2477876 4.42477876,16.2477876 L4.42477876,16.2477876 L12.5132743,16.2477876 Z M12.5132743,14.7610619 L4.42477876,14.7610619 L4.42477876,4.42477876 L12.5132743,4.42477876 L12.5132743,14.7610619 Z" />
                        </svg>
                        </a>
                    </li>
                )}
                {this.state.hasError && <ErrorRenderer errorMessage={this.state.errorMessage}/>}
            </li>
        );
    }

    private async reportHubStats(domainName: string, filespaceName: string | undefined): Promise<void> {
        if (!filespaceName) {
            return;
        }
        const api = await createDefaultApi();
        try {
            const hubResult = await api.reportHubStats(domainName, filespaceName);
            if (hubResult.body.hub && hubResult.body.hub.dataEndpoints) {
                const hubsCheck = hubResult.body;
                this.setState(
                    {
                        filespaceUUID: hubsCheck.fileSystemId,
                        hubEndpoint: `${hubsCheck.hub.dataEndpoints[0]}, ${hubsCheck.hub.dataEndpoints[1]}`,

                    });
                return;
            }
        } catch (e) {
            this.setState({hasError: true, errorMessage: e.message});
        }
    }

}


// WEBPACK FOOTER //
// ./src/backoffice/components/common/HubInfo.tsx